export const addProjects = (list) => {
  const projectsList = document.querySelector('[data-projects]');

  if (projectsList)
    projectsList.appendChild(list)
}